// Compra rápida dos cards (snippets/body-adicionar.liquid): home, sugestões e Combina com.
import { CartLinesUpdateEvent } from '@shopify/events';

// "Adicionar" das sugestões (snippets/body-adicionar.liquid): põe no carrinho sem sair da página
// e sem abrir o carrinho lateral. Avisa o Horizon como atualização ('update'), para a sacola e o
// conteúdo do carrinho se atualizarem; o carrinho só abre pelo "Ver carrinho" do aviso.
const aviso = (() => {
  let el, tempo;
  return (titulo, imagem) => {
    if (!el) {
      el = document.createElement('div');
      el.className = 'body-aviso-carrinho';
      el.setAttribute('role', 'status');
      el.hidden = true;
      document.body.append(el);
      el.addEventListener('click', (e) => {
        if (e.target.closest('[data-body-ver-carrinho]')) {
          el.hidden = true;
          document.querySelector('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]')?.click();
        } else if (e.target.closest('[data-body-fechar-aviso]')) el.hidden = true;
      });
    }
    const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    el.innerHTML = `${imagem ? `<img src="${esc(imagem)}" alt="" width="48" height="48">` : ''}
      <p><span>Você adicionou ao seu carrinho:</span> <b>${esc(titulo)}</b></p>
      <button type="button" class="body-aviso-carrinho__ver" data-body-ver-carrinho>Ver carrinho</button>
      <button type="button" class="body-aviso-carrinho__fechar" data-body-fechar-aviso aria-label="Fechar aviso">&times;</button>`;
    el.hidden = false;
    clearTimeout(tempo);
    tempo = setTimeout(() => { el.hidden = true; }, 7000);
  };
})();

document.addEventListener('click', async (e) => {
  const b = e.target.closest('button[data-body-adicionar]');
  if (!b) return;
  e.preventDefault();
  e.stopPropagation();
  if (b.getAttribute('aria-busy') === 'true') return;
  b.setAttribute('aria-busy', 'true');
  const id = b.dataset.bodyAdicionar;
  const secoes = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const adiado = CartLinesUpdateEvent.createPromise();
  b.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: adiado.promise }));
  try {
    const dados = new FormData();
    dados.append('id', id);
    dados.append('quantity', '1');
    if (secoes.length) dados.append('sections', secoes.join(','));
    const resp = await (await fetch('/cart/add.js', { method: 'POST', body: dados, headers: { Accept: 'application/json' } })).json();
    const carrinho = await (await fetch('/cart.js')).json();
    adiado.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrinho), detail: { items: carrinho.items, source: 'body-adicionar', sourceId: 'body-adicionar', itemCount: 1, sections: resp.sections, didError: !!resp.status } });
    document.querySelector('cart-icon')?.renderCartBubble?.(carrinho.item_count);
    if (!resp.status) aviso(b.dataset.titulo, b.dataset.imagem);
  } catch (erro) {
    adiado.reject(erro);
  } finally {
    b.removeAttribute('aria-busy');
  }
}, true);
